import { useEffect, useState } from "react"
import { ServiceCard } from "../service-card"
import { Link } from "react-router-dom"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"
import { Heart, Brain, Bone, Baby, ChevronRight } from "lucide-react"

export default function OurSpecialtieswidget() {

  const [data, setData] = useState(null)

  useEffect(() => {
    fetch("/wp-json/custom/v1/specialties")
      .then(res => res.json())
      .then(res => setData(res))
  }, [])

const getIcon = (icon) => {
  const value =
    typeof icon === "object" ? icon.value : icon?.toLowerCase()

  switch (value) {
    case "heart":
      return <Heart className="w-10 h-10 text-primary" />
    case "brain":
      return <Brain className="w-10 h-10 text-primary" />
    case "bone":
      return <Bone className="w-10 h-10 text-primary" />
    case "baby":
      return <Baby className="w-10 h-10 text-primary" />
    default:
      return null
  }
}
  if (!data) return null

  return (
    <section className="py-12 bg-white">
      <div className="container px-4 mx-auto">

        <div className="flex flex-col items-center mb-10 text-center">
          <Badge className="mb-2">Our Specialties</Badge>

          <h2 className="mb-4 text-3xl font-bold md:text-4xl">
            {data.title}
          </h2>

          <p className="max-w-2xl text-muted-foreground">
            {data.description}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">

        {data.items?.map((item, index) => (
          <ServiceCard
            key={index}
            icon={getIcon(item.icon)}  // ✅ THIS IS IMPORTANT
            title={item.title}
            description={item.description}
            href={item.link}
          />
        ))}

        </div>

        <div className="flex justify-center mt-8">
          <Button
            variant="outline"
            className="gap-2 border-primary text-primary hover:bg-primary hover:text-white"
            asChild
          >
            <Link to={data.button_link || "/services"}>
              {data.button_text || "View All Specialties"}
              <ChevronRight className="w-4 h-4" />
            </Link>
          </Button>
        </div>

      </div>
    </section>
  )
}